const join = [
  {
    path: "/join/examine",
    name: "joinExamine",
    component: () => import("@/view/join/examine"),
  },
];
export default join;
